import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z","key":"svg-0"}]]

const IconBrandOpenSource = createReactComponent('outline', 'brand-open-source', 'BrandOpenSource', __iconNode);

export default IconBrandOpenSource;